import React from 'react'
import { Button, Modal } from '../../../components'
import './aprovaracaomodal.scss'

const AprovarAcaoModal = ({
  open,
  close,
  nls,
  nomePlano,
  dataFinalCheck,
  dataInicialMin,
  dataFinalMax,
  loadingJanela,
  loadingSubmit,
  onChangeDataFinalCheck,
  onConfirmar
}) => {
  return (
    <Modal open={open} close={close} title={nls.aprovarAcao} size="medium">
      <div className="pdca-aprovaracao-modal">
        <div className="pdca-aprovaracao-modal__nome">{nomePlano}</div>

        <div className="pdca-aprovaracao-modal__campo">
          <label className="pdca-aprovaracao-modal__label">{nls.dataFinalCheck}</label>
          <input
            type="date"
            value={dataFinalCheck}
            min={dataInicialMin || undefined}
            max={dataFinalMax || undefined}
            onChange={onChangeDataFinalCheck}
            disabled={loadingJanela || loadingSubmit}
          />
        </div>

        <div className="pdca-aprovaracao-modal__acoes">
          <Button
            color="primary"
            onClick={onConfirmar}
            disabled={loadingJanela || loadingSubmit || !dataFinalCheck}
          >
            {nls.confirmar}
          </Button>

          <Button
            onClick={close}
            disabled={loadingSubmit}
          >
            {nls.cancelar}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default AprovarAcaoModal